import type { Suggestion } from '../../aiSuggestionsPluginType';
import type { SuggestionAvatarProfile } from '../components/SuggestionAvatar';

/**
 * Builds the deduped avatar list for a block's suggestions. Every suggestion is Rovo-created, so
 * each contributes one agent avatar — the specific agent if `createdByAgent` is set, otherwise the
 * generic Rovo logo (a `profile`-less slot). Human authors (`createdByUser`) are deliberately not
 * shown. Profiles are deduped by account id — `undefined` being the key every generic Rovo slot
 * shares — so repeated agents collapse into a single stack entry.
 */
export function getUniqueAvatarProfiles(
	suggestionIds: Set<string> | undefined,
	suggestionById: Map<string, Suggestion> | undefined,
): SuggestionAvatarProfile[] {
	const profilesByAccountId = new Map<string | undefined, SuggestionAvatarProfile>();

	for (const suggestionId of suggestionIds ?? []) {
		const suggestion = suggestionById?.get(suggestionId);
		if (!suggestion) {
			continue;
		}

		const agent = suggestion.createdByAgent ?? undefined;
		if (!profilesByAccountId.has(agent?.accountId)) {
			profilesByAccountId.set(agent?.accountId, { profile: agent });
		}
	}

	return Array.from(profilesByAccountId.values());
}
